import { render, staticRenderFns } from "./pop-water.vue?vue&type=template&id=7dbbad8c&scoped=true&"
import script from "./pop-water.vue?vue&type=script&lang=js&"
export * from "./pop-water.vue?vue&type=script&lang=js&"
import style0 from "./pop-water.vue?vue&type=style&index=0&id=7dbbad8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbbad8c",
  null
  
)

export default component.exports